import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { FaMapMarkerAlt } from "react-icons/fa";
import { getAddressNameList } from "./installationApi";
import {
  InstallationPickerOption,
  InstallationPickerRow,
  InstallationPickerSheet,
} from "./InstallationPickerSheet";

const InstallationAddressSection = ({
  corporationId,
  addressId,
  addressName,
  onAddressSave,
  divided,
  disabled,
  saving,
}) => {
  const { t } = useTranslation();
  const [addresses, setAddresses] = useState([]);
  const [sheetOpen, setSheetOpen] = useState(false);
  const [draftAddressId, setDraftAddressId] = useState(addressId);
  const [draftAddressName, setDraftAddressName] = useState(addressName);
  const api = process.env.REACT_APP_API_BACKEND;
  const token = Cookies.get("userToken");

  useEffect(() => {
    if (!corporationId || !token) {
      return;
    }
    getAddressNameList(api, token, corporationId)
      .then(setAddresses)
      .catch(() => setAddresses([]));
  }, [api, token, corporationId]);

  useEffect(() => {
    if (sheetOpen) {
      setDraftAddressId(addressId);
      setDraftAddressName(addressName);
    }
  }, [sheetOpen, addressId, addressName]);

  const displayAddress = addressName?.trim() || t("installation_address_empty");
  const isDirty = draftAddressId !== addressId;

  const closeSheet = () => {
    setDraftAddressId(addressId);
    setDraftAddressName(addressName);
    setSheetOpen(false);
  };

  const handleSave = async () => {
    const saved = await onAddressSave(draftAddressId, draftAddressName);
    if (saved) {
      setSheetOpen(false);
    }
  };

  return (
    <>
      <InstallationPickerRow
        icon={FaMapMarkerAlt}
        iconVariant="site"
        title={t("installation_address_picker_label")}
        subtitle={displayAddress}
        placeholder={t("installation_address_placeholder")}
        onClick={() => setSheetOpen(true)}
        disabled={disabled || saving || (addresses.length === 0 && !addressId)}
        divided={divided}
      />

      <InstallationPickerSheet
        open={sheetOpen}
        title={t("installation_picker_title_address")}
        dirty={isDirty}
        saving={saving}
        onDismiss={closeSheet}
        onSave={() => void handleSave()}
      >
        {addresses.length === 0 ? (
          <p className="installation-picker-empty">
            {t("installation_address_empty")}
          </p>
        ) : (
          addresses.map((entry) => (
            <InstallationPickerOption
              key={entry._id}
              label={entry.name}
              selected={entry._id === draftAddressId}
              onSelect={() => {
                setDraftAddressId(entry._id);
                setDraftAddressName(entry.name);
              }}
            />
          ))
        )}
      </InstallationPickerSheet>
    </>
  );
};

export default InstallationAddressSection;
